// TanStack Query cache keys for admin/payouts.
export const adminPayoutKeys = {
  all: ["admin", "payouts"] as const,
  status: () => ["admin", "payouts", "status"] as const,
  assets: () => ["admin", "payouts", "assets"] as const,
  history: (params: Record<string, unknown>) =>
    ["admin", "payouts", "history", params] as const,
};
